/**
 * Separates thousands in a given text or number with a period (.)
 * @param {string | number} text - The text or number to separate the thousands for
 * @returns {string} - The text with separated thousands
 */
export function separateThousands(text: string | number) {
  return String(text).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/**
 * Reverses the thousands separator of a given string, returns a number
 * @param {string} value - The string value with thousands separator
 * @returns {number} - The numeric value without thousands separator
 */
export function reverseThousandSeparator(value: string): number {
  if (!value) return 0;
  return parseFloat(value.replace(/[.,]/g, ''));
}

/**
 * Removes the decimal point from a number and returns the resulting integer.
 * @param num The number to be processed.
 * @returns The integer value with the decimal point removed.
 */
export function removeDecimal(num: number): number {
  // Convert number to string
  const numAsString: string = num.toString();
  // Remove decimal point
  const numWithoutDecimal: string = numAsString.replace(/\./g, '');
  // Convert string back to number
  const result: number = parseInt(numWithoutDecimal);
  // Return the resulting integer
  return result;
}
